<template>
<div class="row">
    <fieldset style="text-align: left;padding: 30px;">
        <div class="row">
            <div class="col-md-12 mb-2">
                <h5>Event Assessment Execution</h5>
            </div>
        </div>
        <div class="row">
            <div v-if="this.updateTraining.typetraining_id == 1" class="d-flex flex-row bd-highlight mb-3" style="padding-left:12px">

                <div class="bd-highlight">
                    <div class="form-check">
                        <vs-checkbox v-model="preAssesment" @change="handlePreChange($event)" :disabled="!isDateValid">
                            <b>PreAssesment</b>
                            <br />
                            <span class="text-success">Enable</span>
                        </vs-checkbox>
                    </div>
                </div>
                <div class="bd-highlight">
                    <div class="form-check">
                        <vs-checkbox v-model="postAssesment" @change="handlePostChange($event)" :disabled="!preAssesment || !isDateValid">
                            <b>PostAssesment</b>
                            <br />
                            <span class="text-success">Enable</span>
                        </vs-checkbox>
                    </div>
                </div>
                <div class="bd-highlight">
                    <div class="form-check">
                        <vs-checkbox v-model="traineefeedback" @change="handleFeedbackChange($event)" :disabled="!postAssesment || !isDateValid">
                            <b>Feedback</b>
                            <br />
                            <span class="text-success">Enable</span>
                        </vs-checkbox>
                    </div>
                </div>
                <div class="bd-highlight">
                    <div class="form-check">
                        <vs-checkbox v-model="trainingStatus" @change="handleTrainingStatusChange($event)" :disabled="!traineefeedback || !isDateValid">
                            <b>Event</b>
                            <br />
                            <span class="text-success">Closure</span>
                        </vs-checkbox>
                    </div>
                </div>

            </div>

            <!-- --- -->
            <div v-else class="d-flex flex-row bd-highlight mb-3" style="padding-left:12px">

                <div class="bd-highlight">
                    <div class="form-check">
                        <vs-checkbox v-model="trainingStatus" @change="handleTrainingStatusChange($event)">
                            <b>Event</b>
                            <br />
                            <span class="text-success">Closure</span>
                        </vs-checkbox>
                    </div>
                </div>

            </div>
            <div class="table-responsive">
                <div class="col-sm-12">
                    <!-- new form popup starts -->
                    <div class="form-group">
                        <div class="row">
                            <div class="col-sm-12">
                                <table class="table table-hover">
                                    <tr>
                                        <th>Sr#</th>
                                        <th>Name</th>
                                        <th>CNIC Number</th>
                                        <th>Contact Number</th>
                                        <th>Username</th>
                                        <th>Pre</th>
                                        <th>Post</th>
                                    </tr>

                                    <tr v-for="(item, index) in itemsTrainee" v-bind:key="item.id">
                                        <td>{{index+1}}</td>
                                        <td v-if="item.name != null" class="text-capitalize">
                                            {{item.name}}
                                        </td>
                                        <td v-else>NULL</td>
                                        <td v-if="item.cnic != null">
                                            {{item.cnic}}
                                        </td>
                                        <td v-else>NULL</td>
                                        <td v-if="item.contactNo != null">
                                            {{item.contactNo}}
                                        </td>
                                        <td v-else>NULL</td>
                                        <td v-if="item.username != null">
                                            {{item.username}}
                                        </td>
                                        <td v-else>NULL</td>
                                        <td v-if="item.preassesmentcheck =='found'">
                                            <span>
                                                <vs-icon class="mr-1" icon="check" style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                            </span>
                                        </td>
                                        <td v-else>
                                            <vs-icon class="mr-1" icon="close" style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                        </td>
                                        <td v-if="item.postassesmentcheck =='found'">
                                            <span>
                                                <vs-icon class="mr-1" icon="check" style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                            </span>
                                        </td>
                                        <td v-else>
                                            <vs-icon class="mr-1" icon="close" style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- new form popup ends -->
                </div>
            </div>
        </div>
    </fieldset>
</div>
</template>

<script>

import axios from "axios";

export default {
    data: () => ({

        preAssesment: "",
        postAssesment: "",
        traineefeedback: "",
        trainingStatus: "",
        role: "",
        success: "",
        error: "",
        cnic: "",
        updateTraining: [],
        trainingId: "",
        trainingCode: "",
        roleuser: "",
        code: "",
        name: "",
        trainingArr: [],
        itemsTrainee: [],
        training_status: "",

    }),
    watch: {

    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')

        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios
            .get(
                localStorage.getItem("BASE_PATH") +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.updateTraining = response.data.training;
                this.trainingId = response.data.training.id;
                this.training_status = response.data.training.trainingstatus;

                this.allTrainer();

                if (response.data.training) {
                    this.preAssesment = response.data.training.preassesment_status || this.preAssesment;
                    this.postAssesment = response.data.training.postassesment_status || this.postAssesment;
                    this.traineefeedback = response.data.training.feedbackstatus || this.traineefeedback;
                    this.trainingStatus = response.data.training.close_status || this.trainingStatus;
                }
            });

        this.openLoading();
        axios
            .get(localStorage.getItem("BASE_PATH") + "/traineeroles/get")
            .then(response => {

                this.closeLoading();
                this.role = response.data[0].id;
            });
        //select all Training Name
        this.openLoading();
        axios
            .get(localStorage.getItem("BASE_PATH") + "/trainers/get")
            .then(response => {

                this.closeLoading();
                this.trainingArr = response.data;
            });
    },
    

    methods: {
        // onclick show wizard steps

        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        handlePreChange: function (e) {
            e.stopPropagation();
            e.preventDefault();
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/enable-preassesment/" +
                    this.trainingId +
                    "/" +
                    this.preAssesment

                )
                .then(response => {

                    this.closeLoading();
                    if(response.data.success){
                        this.toastSuccess('Pre assessment enabled successfully');
                    }else{
                        this.toastError('Pre assessment not enabled');
                    }
                });
        },
        handleTrainingStatusChange: function (e) {
            e.stopPropagation();
            e.preventDefault();
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/close-training/" +
                    this.trainingId +
                    "/" +
                    this.trainingStatus

                )
                .then(response => {
                    this.closeLoading();
                    if(response.data.success){
                        this.toastSuccess('Event closure enabled successfully');
                    }else{
                        this.toastError('Event closure not enabled');
                    }
                });
        },
        handlePostChange: function (e) {
            e.stopPropagation();
            e.preventDefault();
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/enable-postassesment/" +
                    this.trainingId +
                    "/" +
                    this.postAssesment
                )
                .then(response => {
                    this.closeLoading();
                    if(response.data.success){
                        this.toastSuccess('Post assessment enabled successfully');
                    }else{
                        this.toastError('Post assessment not enabled');
                    }
                });
        },
        handleFeedbackChange: function (e) {
            e.stopPropagation();
            e.preventDefault();
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") +
                    "/enable-feedback/" +
                    this.trainingId +
                    "/" +
                    this.traineefeedback

                )
                .then(response => {
                    this.closeLoading();
                    if(response.data.success){
                        this.toastSuccess('Feedback enabled successfully');
                    }else{
                        this.toastError('Feedback not enabled');
                    }
                });
        },
        allTrainer: function allTrainer() {
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") + "/trainee/show/" + this.trainingId

                )
                .then(response => {

                    this.closeLoading();

                    this.itemsTrainee = response.data;
                });
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        showinputvalue: function (event) {
            this.name = event.target.value;
        },

    }
};
</script>

<style scoped>
#msform fieldset {
    padding: 10px;
    background: #f7f7f7;
    border: 0 none;
    border-radius: 2rem;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    border: 2px solid #ccc;
    padding-bottom: 20px;
    position: relative;
}

#msform fieldset:not(:first-of-type) {
    display: none;
}

#msform fieldset .form-card {
    text-align: left;
    color: #9e9e9e;
}

select.list-dt {
    border: none;
    outline: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 5px 3px 5px;
    margin: 2px;
}

select.list-dt:focus {
    border-bottom: 2px solid skyblue;
}
</style>
